import React, {useEffect, useState, useContext} from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Row, Col, Button } from "antd";
import UserContext from '../../../.././contexts/userContext';
import CustomerFeatureCard from "../../widgets/cards/advance/customerFeatureCard";
import OrdersFeatureCard from "../../widgets/cards/advance/ordersFeatureCard";
import SaleFeatureCard from "../../widgets/cards/advance/saleFeatureCard";


const ECommerce = () => {
  const [totalRequests, setTotalRequests] = useState();
  const [totalPO, setTotalPo] = useState(0);
  const [totalInvoice, setTotalInvoice] = useState(0);
  const token = localStorage.getItem("token").replace(/['"]+/g, '');

  const { userprofile } = useContext(UserContext);

  
  useEffect(() => {
    axios.get('https://internal.orevan-prox.com/orevan_requests/list_all_requests/', { headers: {"Authorization" : `Token ${token}`} })  
      .then((res) => {
        let invoicesCount = 0
        let requestsCount = 0
        let poCount = 0

        setTotalRequests(requestsCount)
        setTotalInvoice(invoicesCount)
        setTotalPo(poCount)
      })
      .catch((err) => {
        console.log(err);
      });

  }, [userprofile]);
  
  const history = useHistory();
  
  const routeChange = () =>{ 
    let path = `po-dashboard/request-order`; 
    history.push(path);
  }


  return (
    <Row gutter={[32, 0]}>
      <Col span={24}>
        <Row align="middle" justify="space-between">
          <Col md={15} span={24}>
            <h3>Welcome back, {userprofile?.name} 👋</h3>

            <p className="hp-p1-body hp-mb-0">
              Your current status and analytics are here
            </p>
          </Col>
          <Col className="hp-mt-sm-24 hp-mt-8">
              <Button type="primary" size="large" onClick={routeChange}> New request ? </Button>
          </Col>
        </Row>

      </Col>

      <Col span={24} className="hp-mt-32">
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[32, 32]}>
              <Col xl={8} md={12} span={24}>
                <CustomerFeatureCard totalRequests={totalRequests}/>
              </Col>

              <Col xl={8} md={12} span={24}>
                <SaleFeatureCard totalPO={totalPO}/>
              </Col>

              <Col xl={8} md={12} span={24}>
                <OrdersFeatureCard totalInvoice={totalInvoice}/>
              </Col>

            </Row>
          </Col>

        </Row>
      </Col>
    </Row>
  );
};

export default ECommerce;